import { useQuery } from '@tanstack/react-query';

import publicApiClient from '@shared/publicApiClient';

import type { CreditRateVersion } from './creditRates';

const useAiCreditRates = () =>
  useQuery<CreditRateVersion[]>({
    queryKey: ['ai-credit-rates'],
    queryFn: async ({ signal }) => {
      const versions = (await publicApiClient.get<CreditRateVersion[]>('/ai/credits/rates', { signal })).data;
      if (versions.length === 0) throw new Error('No AI credit-rate versions are available.');
      return versions;
    },
    retry: false,
  });

export default useAiCreditRates;
